<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // 定义最大的 fontSize
    const MAX_FONT_SIZE = 192;
    const MIN_FONT_SIZE = 37.5;
    // 监听 HTML 文档被解析完成的事件
    document.addEventListener("DOMContentLoaded", () => {
      // 获取html标签
      const html = document.querySelector("html");
      // 屏幕的宽度除以10，获取跟元素fontSize标准
      let fontSize = window.innerWidth / 10;
      // 获取到的 fontSize 标准不允许超过我们定义的最大值
      fontSize = fontSize > MAX_FONT_SIZE ? MAX_FONT_SIZE : fontSize;
      fontSize = fontSize < MIN_FONT_SIZE ? MIN_FONT_SIZE : fontSize;
      // 定义根元素 大小
      html.style.fontSize = fontSize + "px";
    });
  },
  mounted() {
    window.addEventListener(
      "resize",
      function () {
        const MAX_FONT_SIZE = 192;
        const MIN_FONT_SIZE = 37.5;
        //监听横竖屏切换
        const html = document.querySelector("html");
        // 屏幕的宽度除以10，获取跟元素fontSize标准
        let fontSize = window.innerWidth / 10;
        // 获取到的 fontSize 标准不允许超过我们定义的最大值
        fontSize = fontSize > MAX_FONT_SIZE ? MAX_FONT_SIZE : fontSize;
        fontSize = fontSize < MIN_FONT_SIZE ? MIN_FONT_SIZE : fontSize;
        // 定义根元素 大小
        html.style.fontSize = fontSize + "px";
      },
      false
    );
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  /* overflow-y: auto;
  overflow-x: hidden; */
}
div {
  font-size: 0.083333rem;
}
body {
   width: 100%;
  /* max-width: 1920px; */
  margin: 0 auto!important;
}
.container {
  width: 100%;
  margin: 0 auto;
}
/* 响应式rem设计 */
/* html {
  font-size: 62.5%;
}
p {
  font-size: 1.8rem;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue